import { useIntl } from 'react-intl';
import { PolicyRule } from '../../../model/interfaces/policyRule';
import { FilterField } from '../../../modules/filterSort/filterField';
import { TitledPaper } from '../../../modules/components/titledPaper/titledPaper';
import { PlusButton } from '../../../modules/components/titledPaper/titledPaperWithAddButton/addButton';
import { ScrollableStack } from '../../../modules/components/scrollableStack';
import { Checkbox, Stack, Typography } from '@mui/material';
import RuleListItem from '../../../modules/listings/ruleListItem';
import { useFilteredAndSorted } from '../../../modules/filterSort/useFilteredAndSorted';

interface ActiveRulesProps {
  rules: PolicyRule[];
  onAddNew: () => void;
  onSelectRule: (rule: PolicyRule) => void;
  selectedRule: PolicyRule | null;
  showAllRules: boolean;
  setShowAllRules: (value: boolean) => void;
}

export const ActiveRules = (props: ActiveRulesProps) => {
  const { rules, onAddNew, onSelectRule, selectedRule, showAllRules, setShowAllRules } = props;

  const [filteredAndSortedRules, setFilter] = useFilteredAndSorted(rules);
  const intl = useIntl();

  return (
    <Stack direction="row" height="inherit" style={{ marginLeft: '10px' }}>
      <TitledPaper
        title={intl.formatMessage({
          id: 'Rules'
        })}>
        <FilterField setFilter={setFilter} />
        <PlusButton onClick={onAddNew} label={intl.formatMessage({ id: 'AddNewRule' })} />
        <Stack direction={'row'} alignItems={'center'}>
          <Checkbox
            checked={showAllRules}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setShowAllRules(event.target.checked)
            }
          />
          <Typography>
            {intl.formatMessage({
              id: 'CheckBoxShowAllRules'
            })}
          </Typography>
        </Stack>
        <ScrollableStack spacing={1} sx={{ overflowX: 'hidden', maxWidth: '100%' }}>
          {filteredAndSortedRules.map((rule) => (
            <RuleListItem
              rule={rule}
              onSelectRule={onSelectRule}
              selected={selectedRule?.policyRuleId === rule.policyRuleId}
              key={rule.policyRuleId}
              {...rule}
            />
          ))}
        </ScrollableStack>
      </TitledPaper>
    </Stack>
  );
};
